<div class="modal-body">
        <div class="register-form pt-3">
          <form [formGroup]="paymentForm">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-bottom: 5px;">
                <div class="formSection">
                  <div class="head">
                    <strong>Payment Information</strong>
                  </div>
                </div>
                <div class="form-background">
                  <div class="row" style="padding: 10px;">
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Mode of Receipt <span class="formMandatoryInput">*</span></label>
                        <ng-select formControlName="paymentModeId" (change)="ReceiptMode()"
                          [ngClass]="{'is-invalid': Submitted && f['paymentModeId'].errors}">
                          <ng-option value="">Select Receipt Mode</ng-option>
                          <ng-option *ngFor="let emp of paymentModeList"
                            [value]="emp.id">{{emp.paymentModeName}}</ng-option>
                        </ng-select>
                        <div *ngIf="Submitted && f['paymentModeId'].errors" style="color: red; font-size: 12px;">Receipt
                          mode is reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Project Bank Account <span class="formMandatoryInput">*</span></label>
                        <ng-select formControlName="bankAccountId" id="ProjectBank"
                          [ngClass]="{'is-invalid': Submitted && f['bankAccountId'].errors}">
                          <ng-option value="">Select Project Bank Account</ng-option>
                          <ng-option *ngFor="let bank of projectBankList" [value]="bank?.id">
                            {{bank?.bankDisplayName}}</ng-option>
                        </ng-select>

                        <div *ngIf="Submitted && f['bankAccountId'].errors" style="color: red; font-size: 12px;">Project
                          Bank Account
                          is reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Client Name <span class="formMandatoryInput">*</span></label>
                        <ng-select formControlName="clientId"
                          [ngClass]="{'is-invalid': Submitted && f['clientId'].errors}"
                          (change)="getClientBookings($event)" [readonly]="this.currentReceipt?.currentRecord">
                          <ng-option value="">Select Client Name</ng-option>
                          <ng-option *ngFor="let customer of clientList" [value]="customer.id">Mr.
                            {{customer?.firstName}}
                            {{customer?.lastName}}</ng-option>
                        </ng-select>

                        <div *ngIf="Submitted && f['clientId'].errors" style="color: red; font-size: 12px;">Client
                          name is reqiured.</div>
                      </div>
                    </div>

                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Amount <span class="formMandatoryInput">*</span></label>
                        <input type="number" formControlName="amount" class="form-control" placeholder="Amount"
                          value="{{currentReceipt?.amount}}"
                          [ngClass]="{'is-invalid': Submitted && f['amount'].errors}" />
                        <div *ngIf="Submitted && f['amount'].errors" style="color: red; font-size: 12px;">Amount is
                          reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Date of Receipt <span class="formMandatoryInput">*</span></label>
                        <div class="calendra d-flex align-items-center">
                          <p-calendar class="custom-calendar" [(ngModel)]="selectedReceiptDate" appendTo="body"
                            formControlName="paymentDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                            [ngClass]="{'is-invalid': Submitted && f['paymentDate'].errors}" [showIcon]="true"
                            inputId="buttondisplay" [showOnFocus]="false" placeholder="DD/MM/YYYY" />
                        </div>
                        <div *ngIf="Submitted && f['paymentDate'].errors" style="color: red;font-size: 12px;">Receipt
                          date is reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4" *ngIf="chequeDetail">
                      <div class="form-group">
                        <label>Cheque Date</label><span class="formMandatoryInput"> *</span>
                        <div class="calendra d-flex align-items-center">
                          <p-calendar class="custom-calendar" [(ngModel)]="selectedChequeDate"
                            formControlName="chequeDate" dateFormat="dd/mm/yy"
                            [ngClass]="{'is-invalid': Submitted && f['chequeDate'].errors}" [showIcon]="true"
                            inputId="buttondisplay" [showOnFocus]="false" placeholder="DD/MM/YYYY" />
                        </div>
                        <div *ngIf="Submitted && f['chequeDate'].errors" style="color: red;font-size: 12px;">Cheque
                          date is reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Transaction No./Cheque No. <span class="formMandatoryInput">*</span></label>
                        <input type="text" formControlName="transactionNumber" class="form-control" maxlength="50"
                          placeholder="Transaction Number or Cheque Number"
                          [ngClass]="{'is-invalid': Submitted && f['transactionNumber'].errors}">
                        <div *ngIf="Submitted && f['transactionNumber'].errors" style="color: red; font-size: 12px;">
                          Transaction number is reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4" *ngIf="BankN">
                      <div class="form-group">
                        <label>Client's Bank Name <span class="formMandatoryInput">*</span></label>
                        <ng-select formControlName="bankId" [ngClass]="{'is-invalid': Submitted && f['bankId'].errors}">
                          <ng-option value="">Select Client Bank Name</ng-option>
                          <ng-option *ngFor="let bank of bankList" [value]="bank.id">{{bank.bankName}}</ng-option>
                        </ng-select>
                        <div *ngIf="Submitted && f['bankId'].errors" style="color: red; font-size: 12px;">Client Bank
                          name reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Remarks <span class="formMandatoryInput">*</span></label>
                        <textarea type="text" formControlName="remark" class="form-control" placeholder="Remarks">
                          </textarea>
                        <div *ngIf="Submitted && f['remark'].errors" style="color: red; font-size: 12px;">
                          Remark is reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Collected By <span class="formMandatoryInput">*</span></label>
                        <ng-select formControlName="collectedBy"
                          [ngClass]="{'is-invalid': Submitted && f['collectedBy'].errors}">
                          <ng-option value="">Select Collected By</ng-option>
                          <ng-option *ngFor="let stage of collectedByList" [value]="stage.id">{{stage.firstName }}
                            {{stage.lastName}}</ng-option>
                        </ng-select>
                        <div *ngIf="Submitted && f['collectedBy'].errors" style="color: red; font-size: 12px;">
                          Collected by is reqiured.</div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4" *ngIf="isCash">
                      <div class="form-group">
                        <label>Transaction Image</label> &nbsp;
                        <input type="file" class="form-control" name="item" formControlName="paymentTypeCopy" accept="*"
                          (change)="uploadImage($event)" style="font-size: 18px; display: none;" />
                        <img src="{{ paymentAddUpdateIcon }}" height="20" width="20" id="myImg"
                          (click)="setCurrentFileConfig('Transaction')">
                        <i class="pi pi-eye pi-icons ml-2" aria-hidden="true"
                          (click)="setClickPicView('Transaction Pic','')">
                        </i>
                      </div>
                    </div>

                    <div class="form-group col-xs-12 col-sm-12 col-md-2 col-lg-2">
                      <div class="form-group">
                        <label></label>
                        &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <app-picview *ngIf="showclickedPic" (closePicDialogue)="hidePicViewModal()"
                [picData]="picViewData"></app-picview>

              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="false">
                <div class="formSection">
                  <div class="head">
                    <strong>Unit Information</strong>
                  </div>
                </div>
                <div class="form-background">
                  <div class="row" style="padding: 10px;">
                    <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                      <div class="form-group">
                        <label>Unit</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="pad-wrap col-sm-12">
              <div class="form-operation-buttons">
                <button type="submit" class="btn btn-primary mr-2" (click)="onSubmit()">Submit</button>
                <button type="button" class="btn btn-secondary" (click)="closePaymentDialogue()">Cancel</button>
              </div>
            </div>
          </form>
        </div>
      </div>`n<p-dialog [(visible)]="showClient" [closeOnEscape]="false" [modal]="true" [draggable]="false" [resizable]="false">
  <p-header>
    Booking/Allotment List
  </p-header>
  <app-common-list (setValues)="clientValues($event)" [columns]="clientColumns" [rowSelection]="'single'"
    [gridData]="bookingAllotmentList" (hideModal)="hideClient()"></app-common-list>

</p-dialog>

<!--Document Pic upload modal. For uploading document this modal will open -->
<p-dialog [(visible)]="displayDocumentFileDialogue" [closeOnEscape]="false" [modal]="true" [draggable]="false"
  [resizable]="false" [blockScroll]=false [style]="{ width: '30rem' }">
  <p-header>
    Upload {{ documentFileData?.picFor }} Pic
  </p-header>
  <app-document-file [fileDataConfig]='documentFileData'
    (documentFile)="ReceivePaymentFile($event)"></app-document-file>
</p-dialog>

<!-- Document Pic upload modal ends here. -->

